import { createContext } from "react";

const NumeracyContext = createContext(null);

export default NumeracyContext;
